export const StaffLabel = "Staff";
export const CustomerLabel = "Customer";
export const StaffIdLabel = "Staff Id";
export const CustomerIdLabel = "Customer Id";
export const CustomerTypeLabel = "Customer Type";
export const CustomerTypeKey = "customer_type";
export const CustomerNameLabel = "Customer Name";
export const userDraftIdLabel = "user_draft_id";
export const AddStaffLabel = "Add Staff";
export const StaffKey = "staff";
export const StaffNameLabel = "Staff Name";
export const PositionLabel = "Position";
export const PaymentMethodLabel = "Payment Method";
export const PositionKey = "position.role";
export const PhoneNumberLabel = "Phone Number";
export const ContactNoKey = "contact_no";
export const AlternatePhoneNumberLabel = "Alternate Phone Number";
export const AadharCardLabel = "Aadhar Card";
export const DrivingLicenseLabel = "Driving License";
export const AccountHolderNameLabel = "Account Holder Name";
export const AccountNumberLabel = "Account Number";
export const AccountNumberKey = "accountNumber";
export const ReAccountNumberLabel = "Re-Enter Account Number";
export const BankNameLabel = "Bank Name";
export const IFSCLabel = "IFSC Code";
export const AddressLabel = "Address";
export const BillingAddressLabel = "Billing Address";
export const ShippingAddressLabel = "Shipping Address";
export const SameAsBillingAddressLabel = "Same as Billing Address";
export const SameAsBillingAddressTooltipLabel =
  "Enable this option if the address is same as billing address";
export const StreetLabel = "Street";
export const CountryLabel = "Country";
export const StateLabel = "State";
export const CityLabel = "City";
export const PostalCodeLabel = "Postal Code";
export const EmailLabel = "Email";
export const EmailKey = "email";
export const StaffNameKey = "staff_name";
export const newStaffLabel = "New Staff";
export const viewStaffLabel = "View Staff";
export const editStaffLabel = "Edit Staff";
export const newCustomerLabel = "New Customer";
export const viewCustomerLabel = "View Customer";
export const editCustomerLabel = "Edit Customer";
export const ViewFileLabel = "View File";
export const StoreLabel = "Store";

export const CustomerType = [
  { value: "Individual", label: "Individual" },
  { id: 2, value: "Company", label: "Company" },
  { id: 3, value: "Reseller", label: "Reseller" },
];
export const PaymentType = [
  { id: 1, value: "Bank transfer", label: "Bank transfer" },
  { id: 2, value: "Credit card", label: "Credit card" },
  { id: 3, value: "Paypal", label: "Paypal" },
  { id: 4, value: "Cash", label: "Cash" },
];
